import $ from "jquery";
import config from "../config.js";

export default {
	endpoint: config.getEnv().B2B_ROOT_URL_API,
	endpoint_router: config.getEnv().B2B_ROOT_URL_API_ROUTER,
	path: "user",
	sessid: null,
	user: null,
	
	/**
	 * Obtém a sessão atual do usuário na API
	 */
	setSessid: function() {
		this.sessid = window.localStorage.getItem('sessid');
		if (this.sessid == null) {
			this.sessid = "";
		}
	},
	
	/**
	 * Requisita dados via GET
	 * @param {string} uri recurso solicitado a API
	 * @param {string} path área requisitada
	 * @returns Promise do retorno da API
	 */
	get: function(uri, path = this.path) {
		this.setSessid();
		return new Promise((resolve, reject) => {
			$.ajax({
				url: this.endpoint + "/" + path + "/" + uri,
				type: 'get',
				headers: { sessid: this.sessid },
				dataType: 'json',
				success: resolve,
			}).fail(reject);
		});
	},

	get_admin: function(uri) {
		this.setSessid();
		return new Promise((resolve, reject) => {
			$.ajax({
				url: this.endpoint + "/admin/" + uri,
				type: 'get',
				headers: { sessid: this.sessid },
				dataType: 'json',
				success: resolve,
			}).fail(reject);
		});
	},
	
	/**
	 * Envia dados via POST a API
	 * @param {string} uri recurso solicitado a API
	 * @param {Array} data dados a serem enviados
	 * @param {string} path área requisitada
	 * @returns Promise do retorno da API
	 */
	post: function(uri, data = {}, path = this.path) {
		this.setSessid();
		return new Promise((resolve, reject) => {
			$.ajax({
				url: this.endpoint + "/" + path + "/" + uri,
				type: 'post',
				data: data,
				headers: { sessid: this.sessid },
				dataType: 'json',
				success: resolve,
			}).fail(reject);
		});
	},
	
	post_admin: function(uri, data) {
		this.setSessid();
		if (!data) data = {};

		return new Promise((resolve, reject) => {
			$.ajax({
				url: this.endpoint + "/admin/" + uri,
				type: 'post',
				data: data,
				headers: { sessid: this.sessid },
				dataType: 'json',
				success: resolve,
			}).fail(reject);
		});
	},

	post_raw: function(url, data, headers) {
		this.setSessid();
		if (!data) data = {};

		return new Promise((resolve, reject) => {
			$.ajax({
				url: url,
				type: 'post',
				data: data,
				headers: headers,
				success: resolve,
			}).fail(reject);
		});
	},
	
	/**
	 * Envia arquivos via POST a API
	 * @param {string} uri recurso solicitado a API
	 * @param {Array} data dados a serem enviados
	 * @param {string} path área requisitada
	 * @returns Promise do retorno da API
	 */
	upload: function(uri, data, path = this.path) {
		this.setSessid();
		return new Promise((resolve) => {
			let formdata = new FormData();

			for (let i in data) formdata.append(i, data[i]);

			$.ajax({
				url: this.endpoint + "/" + path + "/" + uri,
				method: 'POST',
				type: 'POST',
				headers: { sessid: this.sessid },
				data: formdata,
				contentType: false,
				processData: false,
				cache: false,
				success: resolve,
			}).fail(function(e) {
				console.log(e.responseText);
				resolve({
					error: true,
					data: "Falha no serviço"
				});
			});
		});
	},
	
	/**
	 * Obtém um arquivo do servidor
	 * @param {string} uri recurso solicitado a API
	 * @param {string} path área requisitada
	 * @returns 
	 */
	blob: function(uri, path = this.path) {
		this.setSessid();
		return new Promise((resolve) => {
			let ajax = new XMLHttpRequest();
			ajax.open("GET", this.endpoint + "/" + path + "/" + uri, true);
			ajax.setRequestHeader("sessid", this.sessid);
			ajax.responseType = "blob";
			ajax.onerror = () => {
				resolve(false);
			};
			ajax.onload = () => {
				if (ajax.status != 200) {
					resolve(false);
					return;
				}
				
				let blob_url = URL.createObjectURL(ajax.response);
				resolve(blob_url);
			};
			ajax.send();
		});
	},

	/**
	 * Fecha a sessão atual do usuário
	 * @param {string} path área requisitada
	 */
	logout: async function(path = this.path) {
		this.setSessid();
		await this.post("auth/logout", null, path);
		location.reload();
	},
	
	/**
	 * Solicita o roteiro ao servidor
	 * @param {array} data dados a serem envados
	 * @returns Promise com dados do roteiro gerado
	 */
	routing: function (data) {
		let url = this.endpoint_router;
		let endpoint = "/Routering/Routering";

		if (!data) data = {};
		
		data = JSON.stringify(data);
		
		return new Promise((resolve, reject) => {
			$.ajax({
				url: url + endpoint,
				type: 'post',
				data: data,
				headers: {
					"Accept": "text/plain",
					"Content-Type": "application/json-patch+json",
					"Access-Control-Allow-Origin": "*",
					"Access-Control-Allow-Methods": "POST, GET, OPTIONS, PUT, PATCH, DELETE",
					"Access-Control-Allow-Headers": "Content-Type, X-CSRF-Token, X-Requested-With, Accept, Accept-Version, Content-Length, Content-MD5, Date, X-Api-Version, X-File-Name",
				},
				dataType: 'json',
				success: resolve
			}, 90000).fail(reject);
		});
	},

	getURL: function (url) {
		let char = url[url.length - 1];
		url = char == "/" ? url : url + "/";
		return url;
	},

	getFormattedDate: function(date) {
		return date.split("/").reverse().join("-");
	},

	getERPPedidosDeVendasFiltroDeCargaEStatus: function(uri, token, date) {
		return new Promise((resolve, reject) => {
			$.ajax({
				url: this.getURL(uri) + "servico/integracaoterceiros/PedidosDeVendasFiltroDeCargaEStatus/" + this.getFormattedDate(date) + "/true/true/false",
				//url: this.getURL(uri) + "servico/integracaoterceiros/PedidosDeVendas/" + this.getFormattedDate(date) + "/false",
				method: "GET",
				timeout: 0,
				headers: {
					"Authorization": "Bearer " + token,
					"Access-Control-Allow-Credentials": "true",
					"Access-Control-Allow-Headers": "Content-Type",
					"Access-Control-Allow-Methods": "GET, PUT, POST, DELETE, HEAD, OPTIONS",
					"Access-Control-Allow-Origin": "http://localhost:8080",
					"Content-Type": "application/json",
				},
				success: resolve,
			}).fail(reject);
		});
	},

	getERPObterCadastroGeralPorId: function(uri, token, id) {
		return new Promise((resolve, reject) => {
			$.ajax({
				url: this.getURL(uri) + "servico/integracaoterceiros/ObterCadastroGeralPorId/" + id,
				method: "GET",
				timeout: 0,
				headers: {
					"Authorization": "Bearer " + token
				},
				success: resolve,
			}).fail(reject);
		});
	},

	/*load: async function(label, url, form) {
		// Requisita as informações
		let result = null;
		try {
			result = await this.post(url, form);
		} catch (ex) {
			console.log(ex);
			this.$notification.error("Não foi possível obter a lista de "+ label +".");
			return false;
		}
		// Verifica o resultado retornado
		if (result) {
			if (result.error) {
				if (result.data == "unauthorized") {
					this.$notification.error("Desculpe, sua sessão expirou.");
					setTimeout(() => { 
						this.logout();
						return;
					}, 2000);
				} else {
					this.$notification.error(result.data);
					return false;
				}
			} else {
				return result;
			}
		} else {
			this.$notification.error("Não foi possível obter a lista.");
			return false;
		}
	},*/
}